import React, { forwardRef, useState } from 'react'

import IconInput from './IconInput'
import Input from './Input'

export type PasswordInputProps = React.ComponentProps<typeof Input> & {
  CustomInput?: React.ComponentType<React.ComponentProps<typeof Input>>
  customInputProps?: Record<string, unknown>
  showPasswordLabel: string
  hidePasswordLabel: string
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ showPasswordLabel, hidePasswordLabel, ...props }, ref) => {
    const [isMasked, setMasked] = useState(true)

    return (
      <IconInput
        {...props}
        type={isMasked ? 'password' : props.type ?? 'text'}
        icon={isMasked ? 'eyeClosed' : 'eyeOpen'}
        iconLabel={isMasked ? showPasswordLabel : hidePasswordLabel}
        onIconClick={() => setMasked(value => !value)}
        ref={ref}
      />
    )
  }
)

export default PasswordInput
